<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <el-col :lg="8">
        {{ $t("ordem-servico") }}<small> ({{ total }} registros)</small>
      </el-col>
      <el-col :offset="2" :lg="14">
        <el-form style="float: right; padding: 3px 0" :inline="true">
          <OrderServicesFilter
            v-on:clearFilters="clearFilters"
            ref="filter"
            :userType="user.type"
            v-on:filter="fetchRecords"
          />&nbsp;
          <el-button size="mini" type="primary" @click="add()"
            >Nova ordem de serviço</el-button
          >
        </el-form>
        <el-pagination
          class="right"
          :page-size="filter.records"
          background
          :pager-count="5"
          @current-change="fetchRecords"
          @size-change="changeSize"
          :current-page.sync="filter.page"
          layout="sizes, prev, pager, next"
          :page-sizes="[50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000]"
          :total="total"
        ></el-pagination>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :default-sort="{ prop: 'name', order: 'ascending' }"
    >
      <el-table-column sortable prop="id" label="O.S."></el-table-column>
      <el-table-column
        sortable
        prop="customer.name"
        :label="user.type === '2' ? $t('filial') : $t('cliente')"
        v-if="user.type !== '5'"
      />

      <el-table-column sortable prop="quantity" label="Qtde" />
      <el-table-column sortable prop="status" label="Status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === '1'">Aberto</el-tag>
          <el-tag
            v-else-if="scope.row.status === '2'"
            type="info"
            effect="dark"
          >
            Impressa
          </el-tag>

          <el-tag
            v-else-if="scope.row.status === '3'"
            type="danger"
            effect="dark"
          >
            Fechada
          </el-tag>

          <el-tag
            v-else-if="scope.row.status === '4'"
            type="warning"
            effect="dark"
          >
            Coletada
          </el-tag>

          <el-tag
            v-else-if="scope.row.status === '5'"
            type="success"
            effect="dark"
          >
            Entrege Agencia
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createdAt" :label="$t('data')" />
      <el-table-column label="#" align="right" width="210">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === '1'"
            type="warning"
            icon="el-icon-plus"
            title="Adicionar Objetos"
            @click="addObjects(scope.row.id, scope.row.customer.id)"
            size="mini"
            circle
          />
          <!-- <el-button
            type="primary" 
            icon="el-icon-eleme" 
            title="Encerrar OS" 
            v-if="scope.row.status !== '3'"
            @click="close(scope.row.id, scope.row.name)" 
            size="mini" 
            circle
          /> -->

          <el-button
            type="info"
            icon="el-icon-printer"
            @click="print(scope.row.id, scope.row.name)"
            size="mini"
            circle
          />
          <el-button
            type="danger"
            size="mini"
            v-if="scope.row.status === '1'"
            icon="el-icon-delete"
            @click="remove(scope.row.id, scope.row.name)"
            circle
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom clearfix" v-if="!records">
      <el-row :gutter="5">
        <el-col :lg="8">
          <el-pagination
            :page-size="filter.records"
            background
            @current-change="fetchRecords"
            :current-page.sync="filter.page"
            layout="prev, pager, next"
            :total="total"
            v-show="total > filter.records"
          ></el-pagination>
        </el-col>
        <el-col v-if="historyByTag.length > 0">
          <h5>
            Histórico do objeto:
            <strong style="color: rgb(8, 8, 145)"> {{ tagFilter }}</strong>
          </h5>
          <OsDetailsHistoryTable :history="historyByTag" />
        </el-col>
        <el-col :lg="8" style="margin-top: 2px; float: right">
          <el-dropdown>
            <el-button>
              Exportar
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <download-excel name="ordemservico.xls" :data="tableData">
                  XLS
                </download-excel>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { OrderServicesService } from "@/services/customers/order.services.services";
import { OrderServicesDetailsService } from "@/services/customers/order.services.details.service";
import { UserService } from "@/services/users/user.services";
import OrderServicesFilter from "./components/OrderServicesFilter";
import OsDetailsHistoryTable from "../../services/order.services/Components/OsDetailsHistoryTable.vue";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "OrderServicesList",
  components: {
    OrderServicesFilter,
    OsDetailsHistoryTable,
  },
  props: {
    records: Array,
    customer_id: String,
  },
  data() {
    return {
      total: 0,
      tableData: [],
      historyByTag: [],
      tagFilter: "",
      filter: {
        records: 50,
        page: 1,
      },
      user: {
        type: "1",
      },
    };
  },
  methods: {
    changeSize(size) {
      const vm = this;
      vm.filter.records = size;
      vm.fetchRecords();
    },

    add() {
      const vm = this;
      vm.$router.push({ name: "orderservicesadd" });
    },

    addObjects(os_id, customer_id) {
      const vm = this;
      vm.$router.push({
        name: "addobjectstoorderservice",
        params: {
          id: os_id,
          customer: customer_id,
        },
      });
    },

    remove: function (id) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-ordem-servico", { id: id }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        OrderServicesService.delete(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("ordem-servico-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },

    // close: function (id) {
    //   const vm = this;
    //   this.$confirm(
    //     i18n.t("confirmar-fechamento-ordem-servico", { id: id }),
    //     i18n.tc("aviso"),
    //     {
    //       confirmButtonText: "OK",
    //       cancelButtonText: i18n.tc("cancelar"),
    //       type: i18n.tc("aviso"),
    //       center: true,
    //     }
    //   ).then(() => {
    //     const loading = vm.$loading(vm.$options.loading);
    //     OrderServicesService.close(id)
    //       .then((response) => {
    //         setTimeout(() => {
    //           vm.fetchRecords();
    //         }, 300);
    //         this.$message({
    //           type: "success",
    //           message: i18n.tc("ordem-servico-encerrada-sucesso"),
    //         });
    //       })
    //       .catch((error) => {
    //         vm.$notify.error({
    //           title: i18n.tc("erro"),
    //           message: error,
    //         });
    //       })
    //       .finally(() => loading.close());
    //   });
    // },

    print(id) {
      const vm = this;
      const record = vm.tableData.find((x) => x.id == id);
      const loading = vm.$loading(vm.$options.loading);
      OrderServicesService.print(record.id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response.data;
          downloadLink.download = `${record.id}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    findHistoryByTag(tag) {
      const vm = this;
      OrderServicesDetailsService.findByTag(tag)
        .then((response) => {
          vm.historyByTag = [];
          vm.historyByTag.push(...response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },

    clearFilters() {
      const vm = this;
      vm.fetchRecords();
      vm.historyByTag = [];
    },

    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const ruleForm = vm.$refs.filter.filter;
      const s = moment(ruleForm.range[0]);
      const f = moment(ruleForm.range[1]);

      OrderServicesService.filter(
        vm.filter.records,
        vm.filter.page,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        ruleForm
      )
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());

      if (ruleForm.tag && ruleForm.tag.length > 0) {
        vm.tagFilter = ruleForm.tag;
        vm.findHistoryByTag(ruleForm.tag);
      }
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (vm.records) {
          vm.tableData = vm.records;
        } else {
          vm.fetchRecords();
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
